import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-regular-svg-icons'

import Prescription from '../../../models/prescription'

import './side_bar_item.css'

// FA6 Regular faTrashCanXmark — matches Figma spec exactly
const faTrashCanXmarkFA6 = {
  prefix: 'far',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], null, 'M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm63 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z']
}

const SideBarItem = React.memo(function SideBarItem ({
  id, healthId, name, date, selectedItem, selectPrescription, showRemovePrescriptionModal
}) {
  const prescriptionDate = useMemo(() => new Date(date).toLocaleDateString(navigator.language), [date])

  const sizedName = useMemo(() => {
    if (!name) return null
    const fullPatientName = name.split(' ')
    const numberOfNames = fullPatientName.length
    if (numberOfNames > 4) {
      return fullPatientName.slice(0, 2).join(' ') + ' ' + fullPatientName.slice(numberOfNames - 2).join(' ')
    }
    return name
  }, [name])

  const isSelected = id === selectedItem

  const showModal = useCallback((e) => {
    e.stopPropagation()
    showRemovePrescriptionModal(id)
  }, [id, showRemovePrescriptionModal])

  return (
    <li className={`prescription-card-item${isSelected ? ' selected' : ''}`} onClick={selectPrescription}>
      <div className="prescription-card-bg">
        <div className="prescription-card-top">
          <span className="prescription-card-icon">
            <FontAwesomeIcon icon={faUser} />
          </span>
          {sizedName && <span className="prescription-patient-name">{sizedName}</span>}
        </div>
        <div className="prescription-card-bottom">
          <div className="prescription-info-row">
            <span className="prescription-badge">Nº SNS:</span>
            <span className="prescription-value">{healthId}</span>
          </div>
          <div className="prescription-info-row">
            <span className="prescription-badge">Data:</span>
            <span className="prescription-value">{prescriptionDate}</span>
            <button type="button" className="prescription-delete-btn" onClick={showModal}>
              <FontAwesomeIcon icon={faTrashCanXmarkFA6} />
            </button>
          </div>
        </div>
      </div>
    </li>
  )
})

SideBarItem.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  prescription: PropTypes.instanceOf(Prescription),
  selectedPrescription: PropTypes.func,
  selectedItem: PropTypes.string
}

export default SideBarItem
